module.exports = __webpack_public_path__ + "static/media/more.3c576699.svg";